<template>
  <BasePageLayout title="Журнал действий" >
    <d-action-journal-page
      :table-titles="tableTitles"
      :table-fields="tableFields"
      :group-enum="groupEnum"
      :action-type-enum="actionTypeEnum"
    />
  </BasePageLayout>
</template>

<script>
import { JOURNAL_GROUP_ENUM, JOURNAL_ACTIONTYPE_ENUM } from '@/helpers/consts';
import { BasePageLayout } from '@/components/base/Page/index';

export default {
  name: 'ActionJurnal',
  page: {
    title: 'CRM Doctis - Журнал действий',
  },
  components: {
    BasePageLayout,
  },
  data() {
    return {
      groupEnum: JOURNAL_GROUP_ENUM,
      actionTypeEnum: JOURNAL_ACTIONTYPE_ENUM,
      tableTitles: [
        { title: 'Дата', width: '120px' },
        { title: 'Пользователь', width: '216px' },
        { title: 'Роль', width: '96px' },
        { title: 'ID пользователя', width: '232px' },
        { title: 'Событие', width: '216px' },
        { title: 'ID мониторинга', width: '232px' },
      ],
      // нужные поля для таблицы
      tableFields: [
        'createdAt',
        'user.fullName',
        'user.group',
        'user.id',
        'actionType',
        'monitoringId',
      ],
    };
  },
};
</script>
